import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI);

// 引入jQuery
import $ from 'jquery'
Vue.prototype.$ = $;

// 引入md5
import md5 from 'js-md5';
Vue.prototype.$md5 = md5;

// 引入全局混入
import MinXin from '@/config/miXins.js'
Vue.mixin(MinXin);

// // 新闻详情请求
import ajax_news from '../src/config/ajax';
Vue.prototype.ajax_news = ajax_news;
// // 新闻详情请求
import ajax_content from '../src/config/ajaxContent';
Vue.prototype.ajax_content = ajax_content;

import axios1 from '../src/config/axios';
Vue.prototype.axios1 = axios1;


import axios from 'axios'
import qs from 'qs'
Vue.prototype.$axios = axios    //全局注册，使用方法为:this.$axios
Vue.prototype.qs = qs           //全局注册，使用方法为:this.qs

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
